// extracted by mini-css-extract-plugin
module.exports = {"sns-container":"SocialShareButton_sns-container__zg4Wn"};